import API from "@/API";
import loader from "../../creators/loader";

const SET_PROFESSIONAL = "SET_PROFESSIONAL";

const state = {
  ...loader.state,
  professional: ""
};

const actions = {
  ...loader.actions,

  async show({ _, dispatch }, id) {
    dispatch("startLoader");

    try {
      const response = await API.Professionals.getById(id);

      dispatch("setProfessional", response);
    } catch (e) {
      dispatch("stopLoader");

      throw e;
    }

    dispatch("stopLoader");
  },

  setProfessional({ commit }, professional) {
    commit("SET_PROFESSIONAL", professional);
  },

  async startTraining({ _, dispatch, state }) {
    dispatch("startLoader");

    try {
      await API.Professionals.startTraining(state.professional.id);
      const response = await API.Professionals.getById(state.professional.id);

      dispatch("setProfessional", response);
    } catch (e) {
      dispatch("stopLoader");

      throw e;
    }

    dispatch("stopLoader");
  },

  async approveTraining({ _, dispatch, state }) {
    dispatch("startLoader");

    try {
      await API.Professionals.approveOnTraining(state.professional.id);
      const response = await API.Professionals.getById(state.professional.id);

      dispatch("setProfessional", response);
    } catch (e) {
      dispatch("stopLoader");

      throw e;
    }

    dispatch("stopLoader");
  },

  async reproveOnTraining({ _, dispatch, state }) {
    dispatch("startLoader");

    try {
      await API.Professionals.reproveOnTraining(state.professional.id);
      const response = await API.Professionals.getById(state.professional.id);

      dispatch("setProfessional", response);
    } catch (e) {
      dispatch("stopLoader");

      throw e;
    }

    dispatch("stopLoader");
  }
};

const mutations = {
  ...loader.mutations,

  [SET_PROFESSIONAL](state, professional) {
    state.professional = professional;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/professionals/professional.js